import { Injectable } from '@angular/core';
import { toImmutableMap } from '@datachain/ui-sdk/common';
import { Map as ImMap } from 'immutable';

import dayjs from '../core/configs/dayjs';
import { GroupingTagResponse, ProjectIdLabelResponse } from '../requesters';
import { GroupingTagItemEntity } from './domain/grouping-tag-item.entity';
import { ProjectsForGroupingTag } from './domain/grouping-tag.types';

@Injectable()
export class GroupingTagAdapter {
	public generateGroupingTagList(
		response: ReadonlyArray<GroupingTagResponse>
	): ImMap<string, GroupingTagItemEntity> {
		const items = response.reduce<Array<GroupingTagItemEntity>>((acc, curr) => {
			acc.push(
				GroupingTagItemEntity.build({
					id: curr.id,
					label: curr.code,
					color: curr.color,
					createdOn: curr.created_at ? dayjs(curr.created_at) : null,
					createdBy: curr?.created_by.name ?? '',
				})
			);
			return acc;
		}, []);
		return toImmutableMap(items, 'id');
	}

	public toReferencingProject(
		groupingTagId: string,
		response: ReadonlyArray<ProjectIdLabelResponse>
	): ProjectsForGroupingTag {
		const projects = response.map((rp) => ({
			id: rp.id,
			label: rp.label,
		}));
		return {
			id: groupingTagId,
			projects,
		};
	}
}
